/**
 * A small, calm empty-state line for a list that has nothing in it yet. Not a big
 * illustration — just a friendly sentence, styled to match the menu's own note
 * text, telling a new skipper how to make the first route / mark / track.
 *
 * The copy comes from emptyHints.ts so the wording lives in one place; this is
 * only the little box it sits in.
 */

export function EmptyHint({ children }: { children: React.ReactNode }) {
  return <p className="acp-empty-hint">{children}</p>;
}
